import Attachments from '@/components/DynamicForm/Attachments/Attachments';
const AttachmentsMixin = {
  methods: {
    getDocTypes: Attachments.methods.getDocTypes,
  }
};

import AttachmentsForm from '@/components/DynamicForm/Attachments/AttachmentsForm'
const AttachmentsFormMixin = {
  methods: {
    add: AttachmentsForm.methods.add,
    updateAttachment: AttachmentsForm.methods.updateAttachment,
    createAttachment: AttachmentsForm.methods.createAttachment,
    deleteAttachments: AttachmentsForm.methods.deleteAttachments,
    createRelations: AttachmentsForm.methods.createRelations,
    getAwsCredentials: AttachmentsForm.methods.getAwsCredentials,
    onComplete: AttachmentsForm.methods.onComplete,
    showNotification: AttachmentsForm.methods.showNotification,
    uploadFile: AttachmentsForm.methods.uploadFile,
    uploadToAwsS3: AttachmentsForm.methods.uploadToAwsS3,
  }
}

export default {
  mixins: [AttachmentsMixin, AttachmentsFormMixin],
  data() {
    return {
      docTypes: [],
      attachments: [],
      attachmentData: [],
      isUploadDialogOpen: false,
      promisePending: false,
      snackbarMsg: '',
      isSnackbarOpen: false,
    }
  },
  async mounted() {
    this.docTypes = await this.getDocTypes();
  },
  methods: {
    /**
     * Show attachment upload form
     * @returns {Void}
     */
    onUpload() {
      this.isUploadDialogOpen = true;
    },
    /**
     * Attachment was successfully added or updated
     * Close dialog
     * @returns {Void}
     */
    onUploadSuccess(attachmentData) {
      this.isUploadDialogOpen = false;
      this.attachmentData = attachmentData;
      console.log("attachmentData ", attachmentData);
    },
  },
}

